/* eslint-disable import/prefer-default-export */
import types from '../types/types';

export const setTotalShippingCost = (totalShippingCost, shippingTax) => (
  dispatch
) => {
  dispatch({
    type: types.shippingCost,
    totalShippingCost,
    shippingTax,
  });
};
